// The 7 F10 phases (SPEC F10 "the default process, LowEnd 14"): Spark, Dig, Flip, Drums, Arrange, Mix, Finish, each
// holding some of the wizard steps w01 to w14. Data only: there is no process editor before v1.4. A session
// records the phases a project's activity touched; a stuck check-out names one.

import phasesData from './phases.json';

export interface Phase { id: string; name: string; steps: string[] }

export const PHASES: readonly Phase[] = phasesData;

export type PhaseId = 'spark' | 'dig' | 'flip' | 'drums' | 'arrange' | 'mix' | 'finish';

/** The phase a wizard step belongs to, or undefined for an id that is not a step. */
export function phaseOfStep(stepId: string): Phase | undefined {
  return PHASES.find((p) => p.steps.includes(stepId));
}

export const phaseName = (id: string): string => PHASES.find((p) => p.id === id)?.name ?? id;
